const loading = (el) => {
  if (!el) return;
  if (el.dataset.loaded === "true") return;

  el.dataset.loaded = "true";

  gsap.to(el, {
    height: 0,
    duration: 0.3,
    delay: 0.5,
    onComplete() {
      el.remove();
    },
  });

  const logo = document.querySelector(".js-loading__logo");
  if (logo) {
    gsap.to(logo, {
      opacity: 0,
      duration: 0.3,
    });
  }
};
